import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FolioGuia } from "app/features/componentes/folioguia";

export interface Props {
    value: models.FiltroGuia;
    onChange: (value: models.FiltroGuia) => void;
}


/**
* Componente para editar un FiltroGuia
*/
class FiltroGuiaComponentNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<models.FiltroGuia> {
        return {};
    }

    /**
    Establece la hora desde a la primer hora del día 12:00 am
    */
    private onFechaDesdeChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(0, 0, 0, 0);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaInicio: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaInicio: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    /**
    Establece la hora hasta a la ultima hora del día 11:59 pm
    */
    private onFechaHastaChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(23, 59, 59);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaFinal: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaFinal: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }


    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const Datetime = getField(kea.DateTime);
        const Cliente = getField(selectores.Cliente);
        const Sucursal = getField(selectores.Sucursal);
        const Folio = getField(FolioGuia);
        const StatusFacturacion = getField(selectores.StatusFacturacion);
        return (
            <div>
                {kea.autogrid(3, [
                    <Sucursal field="IdSucursalStatus" label="Sucursal" />,
                    <Datetime field="FechaInicio" label="Fecha de inicio" onChange={this.onFechaDesdeChange} />,
                    <Datetime field="FechaFinal" label="Fecha final" onChange={this.onFechaHastaChange} />,
                    <Cliente field="IdClienteDestino" label="Cliente destino" />,
                    <Cliente field="IdClienteOrigen" label="Cliente origen" />,
                    <Folio field="Folio" />,
                    <StatusFacturacion field="StatusGuiaFacturacion" label="Status guía facturación" />
                ])}
            </div>);
    }
}

export const FiltroGuiaComponent = componentToRx(FiltroGuiaComponentNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/multiguias/filtro.tsx